import { render, staticRenderFns } from "./MenuAlert.vue?vue&type=template&id=da1e996c"
import script from "./MenuAlert.vue?vue&type=script&lang=js"
export * from "./MenuAlert.vue?vue&type=script&lang=js"
import style0 from "./MenuAlert.vue?vue&type=style&index=0&id=da1e996c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports